import axios from "axios";

export const deviceModifyAPI = async (type, addIds, removeIds) => {
  let result = [];
  if (addIds) {
    result.push({
      assign: "add",
      type: type,
      tag_ids: type === "tag" ? addIds : undefined,
      company_ids: type === "company" ? addIds : undefined,
      group_ids: type === "group" ? addIds : undefined
    });
  }
  if (removeIds) {
    result.push({
      assign: "remove",
      type: type,
      tag_ids: type === "tag" ? removeIds : undefined,
      company_ids: type === "company" ? removeIds : undefined,
      group_ids: type === "group" ? removeIds : undefined
    });
  }
  let res = await axios({
    url: `/api/v2/schedule/device-modify`,
    method: "POST",
    data: { modify: result }
  });
  return res.data.taskSchedule;
};
